import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Dialog,
  withMobileDialog,
  Button,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { isMobile } from 'react-device-detect';
import DialogTemplate from 'components/shared/DialogTemplate';
import { Input } from 'components/FormInputs';

const ConfirmPasswordDialog = ({
  fullScreen,
  open,
  onClose,
  onSuccess,
}) => {
  const [password, setPassword] = React.useState('');

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      maxWidth="md"
      open={open}
    >
      <DialogTemplate
        title={(
          <FormattedMessage
            id="Enter your password to confirm"
            defaultMessage="Enter your password to confirm"
          />
        )}
        isNew={false}
        pristine={false}
        onClose={onClose}
        onSave={null}
        isUpdating={false}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Input
              name="pwd"
              errors={{}}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              onKeyPress={(e) => {
                if (e.charCode === 13) {
                  onSuccess(password);
                  setPassword('');
                }
              }}
              autoFocus={!isMobile}
              type="password"
              label={(
                <FormattedMessage
                  id="Enter your password to confirm"
                  defaultMessage="Enter your password to confirm"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'right' }}>
            <Button
              onClick={() => {
                onSuccess(password);
                setPassword('');
              }}
              type="button"
              disabled={!password || password.length < 6}
              variant="contained"
              color="primary"
            >
              <FormattedMessage
                id="Confirm"
                defaultMessage="Confirm"
              />
            </Button>
          </Grid>
        </Grid>
      </DialogTemplate>
    </Dialog>
  );
};

ConfirmPasswordDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(ConfirmPasswordDialog);
